import { useEffect, useRef } from 'react';
import { getAuth, signOut } from 'firebase/auth';


// For a 2-minute timeout
//useIdleLogout(120000);
// For a 15-minute timeout
//useIdleLogout = (timeout = 900000) 
// For a 2-hour timeout
//useIdleLogout(7200000);

const useIdleLogout = (timeout = 7200000) => { // Default timeout is 15 minutes (900000 ms)
  const timer = useRef(null);
  const auth = getAuth();

  const handleLogout = () => {
    signOut(auth).then(() => {
      console.log('User signed out due to inactivity.');
      // You can add a redirect to the login page here if needed
      // window.location.href = '/login';
    }).catch((error) => {
      console.error('Sign out error:', error);
    });
  };

  const resetTimer = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(handleLogout, timeout);
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'touchstart'];

    const reset = () => resetTimer();

    // Set up event listeners
    events.forEach(event => window.addEventListener(event, reset));
    resetTimer(); // Initialize the timer

    // Cleanup function
    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
      events.forEach(event => window.removeEventListener(event, reset));
    };
  }, [timeout]); // Rerun effect if the timeout duration changes

  return null; // This hook does not render anything
};

export default useIdleLogout;